class EventBus {
    events = new Map();
    on(event, callback) {
        if (!this.events.has(event)) {
            this.events.set(event, []);
        }
        this.events.get(event)?.push(callback);
    }
    emit(event, ...args) {
        this.events.get(event)?.forEach(callback => callback(...args));
    }
    off(event, callback) {
        if (this.events.has(event)) {
            const callbacks = this.events.get(event);
            if (callbacks) {
                this.events.set(event, callbacks.filter(cb => cb !== callback));
            }
        }
    }
}
const eventBus = new EventBus();
export default eventBus;
